import React from 'react'
import { csx } from '@vtex/admin-ui'

export type ProductCarouselTitleProps = React.ComponentProps<'p'>

export const ProductCarouselTitle = (props: ProductCarouselTitleProps) => (
  <p
    className={csx({
      display: 'block',
      '@tablet': {
        text: '$title1',
      },
      '@desktop': {
        text: '$display',
      },
    })}
    {...props}
  />
)
